import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import DashboardHeader from '$components/ProductDashboard/DashboardHeader';
import DashboardSubheader from '$components/ProductDashboard/DashboardSubheader';
import PartnerJustin from '$components/Enroll/Purchase/PartnerJustin';
import styles from './styles.scss';
import { track } from '$lib/tracking';

const FinanceFirmReferral = (props) => {
  const { product } = props;
  const { slug: productSlug } = product;
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    track('Corporate referral | Viewed', { productSlug });
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <DashboardHeader header="Work at a financial firm?" />
      <DashboardSubheader>Introduce us to your manager and get $100</DashboardSubheader>
      <div className={styles.terms}>
        <Button onClick={showModal} data-aaa="financialFirmReferral">
          View details
        </Button>
      </div>
      <Modal
        title="Achievable financial firm referral program"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleOk}
      >
        <p>
          Achievable partners with financial firms to help get reps licensed quickly and
          affordably. We&apos;re already working with many of the top financial firms in
          the industry and would love to work with yours too!
        </p>
        <p>
          <b>Just send a brief email connecting us with your manager.</b>
        </p>
        <p>
          We&apos;ll discuss licensing needs with them over email or a call, and will set up an
          organization account including a manager dashboard and the ability to directly
          enroll reps in courses. It&apos;s typically very quick and easy since we do this
          at the branch level and don&apos;t need any formal contracts; we&apos;re
          essentially just setting up a customized online portal.
        </p>
        <p>
          Within 31 days of the first paid enrollment through the organizational account,
          we&apos;ll send you a $100 Amazon gift card as a thank you.
        </p>
        <PartnerJustin />
      </Modal>
    </div>
  );
};

export default FinanceFirmReferral;
